var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hideFooter
    ? _c("footer", { staticClass: "footer" }, [
        _c("div", [
          _c("div", { staticClass: "footer-link" }, [
            _c("div", { staticClass: "columns is-centered is-vcentered" }, [
              _c("div", { staticClass: "column is-narrow" }, [
                _c("div", { staticClass: "is-vcentered" }, [
                  _vm._v(_vm._s(_vm.$t("footer.copyright")) + " "),
                  _c("img", {
                    staticClass: "small-logo",
                    attrs: {
                      src: "/logo-kalilab.png",
                      alt: _vm.$t("alt.kalilab"),
                      draggable: "false",
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "column is-hidden-mobile" }),
              _c(
                "div",
                { staticClass: "column is-narrow" },
                [
                  _c("router-link", { attrs: { to: "/terms" } }, [
                    _vm._v(_vm._s(_vm.$t("menu.terms"))),
                  ]),
                  _c("router-link", { attrs: { to: "/warnings" } }, [
                    _vm._v(_vm._s(_vm.$t("menu.warnings"))),
                  ]),
                  _c("router-link", { attrs: { to: "/privacy" } }, [
                    _vm._v(_vm._s(_vm.$t("menu.privacy"))),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "footer-legal" }, [
            _c(
              "div",
              {
                staticClass:
                  "columns is-centered is-vcentered is-multiline is-mobile",
              },
              [
                _vm._m(0),
                _vm._m(1),
                _c("div", { staticClass: "column is-narrow" }, [
                  _c("span", { staticClass: "no-wrap" }, [
                    _vm._v(
                      _vm._s(_vm.$t("footer.vat", { vat: "09663920016" }))
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "column is-narrow" }, [
                  _c("span", { staticClass: "no-wrap" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("footer.pec", { mail: "kalilabsrl@pec.it" })
                      )
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("span", { staticClass: "no-wrap" }, [_vm._v("KALI LAB. Srl")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("span", { staticClass: "no-wrap" }, [
        _vm._v("Via Stupinigi n.29, 10048 Vinovo (TO)"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }